export const ADD_CONTRACT_TO_PIPELINE = 'ADD_CONTRACT_TO_PIPELINE'
export const GET_PIPELINES = 'GET_PIPELINES'
export const SET_PIPELINES = 'SET_PIPELINES'
export const GET_PIPELINES_FULL_LIST = 'GET_PIPELINES_FULL_LIST'
